import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useI18n } from "@/i18n";

/**
 * <ConfirmDialog open title description confirmLabel onConfirm onCancel destructive />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  destructive = false,
}) {
  const { isRTL } = useI18n();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel">
            {cancelLabel || (isRTL ? "إلغاء" : "Cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok"
            onClick={onConfirm}
            className={destructive ? "bg-red-600 hover:bg-red-700 text-white" : "bg-[#C86240] hover:bg-[#B25535] text-white"}
          >
            {confirmLabel || (isRTL ? "تأكيد" : "Confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function useConfirm() {
  const [state, setState] = React.useState({ open: false });
  const confirm = React.useCallback(
    (opts) => new Promise((resolve) => {
      setState({
        open: true,
        ...opts,
        _resolve: resolve,
      });
    }),
    []
  );
  const handle = (ok) => {
    state._resolve?.(ok);
    setState({ open: false });
  };
  const dialog = (
    <ConfirmDialog
      open={state.open}
      onOpenChange={(o) => !o && handle(false)}
      title={state.title}
      description={state.description}
      confirmLabel={state.confirmLabel}
      cancelLabel={state.cancelLabel}
      destructive={state.destructive}
      onConfirm={() => handle(true)}
    />
  );
  return { confirm, dialog };
}
